import QRCodeEntityDetailPage from './QRCodeEntityDetailPage'
export default QRCodeEntityDetailPage;